// Rules that only apply to the trado editor: what has to be true before verifying / saving.
const useTradoEditorValidation = ({
  uiContext,
  pengecekanSaved,
  pengecekanBerangkatData,
  pengecekanKembaliData,
  pengecekanBerangkatDetilData,
  pengecekanKembaliDetilData,
  saveCekDetil,
  saveDetilMany
}) => {
  const handleValidateVerifikasi = (type) => {
    const detilData = type === "berangkat" ? pengecekanBerangkatDetilData : pengecekanKembaliDetilData;

    for (const detil of detilData) {
      if ((detil.required_gambar == 1 || detil.required_gambar === true) && !detil.gambar) {
        uiContext.showErrorMsg(
          "Error",
          `Gambar untuk "${detil.keterangan}" wajib diisi sebelum verifikasi.`
        );
        return false;
      }
    }

    if (!pengecekanSaved["bagian_depan"]) {
      uiContext.showErrorMsg("Error", "Pengecekan bagian depan belum di-save");
      return false;
    } else if (!pengecekanSaved["bagian_samping"]) {
      uiContext.showErrorMsg(
        "Error",
        "Pengecekan bagian samping belum di-save"
      );
      return false;
    } else if (!pengecekanSaved["bagian_belakang"]) {
      uiContext.showErrorMsg(
        "Error",
        "Pengecekan bagian belakang belum di-save"
      );
      return false;
    } else if (!pengecekanSaved["bagian_dalam"]) {
      uiContext.showErrorMsg("Error", "Pengecekan bagian dalam belum di-save");
      return false;
    } else {
      return true;
    }
  };

  const handleOnClickSaveCheckList = ({ detils, type }) => {
    const missingGambar = detils.find(
      (el) => (el.required_gambar == 1 || el.required_gambar === true) && !el.gambar
    );
    if (missingGambar) {
      uiContext.showErrorMsg(
        "Error",
        `Gambar untuk "${missingGambar.keterangan}" wajib diisi sebelum save.`
      );
      return;
    }
    saveCekDetil({ detils, type });
  };

  const handleOnClickSaveMarkingList = async ({
    type,
    labelGrup,
    pengecekanDetilData,
  }) => {
    const isRequired = pengecekanDetilData.some((el) => el.required_gambar == 1 || el.required_gambar == true);
    const pengecekanData = type === "berangkat" ? pengecekanBerangkatData : pengecekanKembaliData;
    const isGambarEmpty = !pengecekanData[labelGrup];

    if (isRequired && isGambarEmpty) {
      uiContext.showErrorMsg(
        "Error",
        `Gambar untuk ${labelGrup.replace(/_/g, " ")} wajib diisi.`
      );
      return;
    }

    saveDetilMany({ type, labelGrup, pengecekanDetilData });
  };

  return {
    handleValidateVerifikasi,
    handleOnClickSaveCheckList,
    handleOnClickSaveMarkingList
  };
};

export default useTradoEditorValidation;
